<script lang="ts" setup>
  import { useShared, useHttpClient, useRoute } from '@othercommerce/foundation';
  import { ref, watch, nextTick } from 'vue';

  const route = useRoute();
  const shared = useShared();
  const http = useHttpClient();

  const include = ref(shared.value.includeVat ?? true);

  function toggle() {
    nextTick(() => {
      http.post(route('web.vat.store'), { inclusive: include.value });
    });
  }

  watch(() => shared.value.includeVat, (value) => {
    include.value = !!value;
  });
</script>
<template>
  <div class="tax-switch">
    <SfFormSwitch id="tax-switch" v-model="include" reverse @change="toggle">
      {{ include ? $t('SHOP.COMMON.LABEL.VAT_INCLUDED') : $t('SHOP.COMMON.LABEL.VAT_EXCLUDED') }}
    </SfFormSwitch>
  </div>
</template>
<style lang="scss" scoped>
  .tax-switch {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    width: auto;

    --sf-switch-label-weight: var(--font-weight-semi);
  }
</style>
